import React from 'react';
import Main from './components/Main';
import './index.scss';

const FrontWarehouse = () => {
    return (
        <div>
            <Main />
        </div>
    )
}
export default FrontWarehouse
